import { C, SHADOWS } from "../lib/theme";

export function Card({ children, pad = 18, style, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: C.white,
        border: "1px solid rgba(196,193,183,0.25)",
        borderRadius: 16,
        padding: pad,
        boxShadow: SHADOWS.card,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
